module.exports = __webpack_public_path__ + "img/patent8.ef631f34.jpg";